import { deviceInfoUpdateScreenWidth } from '~/store/frontendState/deviceInfo/deviceInfo.actionCreator';
import { type DeviceInfoAction } from './deviceInfo.action';
import { type DeviceInfoState } from './deviceInfo.state';

const deviceInfoInitialState: DeviceInfoState = {
  screenWidth: window.innerWidth,
};

export const deviceInfoReducer = (state = deviceInfoInitialState, action: DeviceInfoAction): DeviceInfoState => {
  if (deviceInfoUpdateScreenWidth.match(action)) {
    return {
      ...state,
      screenWidth: action.payload.screenWidth,
    };
  }

  return state;
};
